import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import { PageSize } from "../../shared/constant";
import Endpoint from "../../shared/endpoints";
import labelConstants from "../constants/labelConstants";

const getLabels = (payload: any) =>
  api.get(Endpoint.retrieveLabels, {
    params: {
      ...(payload.clientId && { client: payload.clientId }),
      page: payload.page,
      search: payload.searchText,
      label_name: payload.labels?.join(", "),
      artist: payload.artist,
      lyricists: payload.lyricist,
      composers: payload.composer,
      title: payload.track,
      platform: payload.platform,
      page_size: PageSize.FIFTY,
    },
  });
const postLabel = (payload: any) => api.post(Endpoint.createLabel, payload);
const editLabel = (id: string, payload: any) =>
  api.patch(`${Endpoint.editLable}/${id}`, payload);

const deleteLabel = (payload: any) =>
  api.delete(`${Endpoint.deleteLabel}/${payload.id}`);

function* retrieveLabels(action: any) {
  try {
    const response: AxiosResponse = yield call(getLabels, action.payload);
    yield put({
      type: labelConstants.GET_LABELS_LIST_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: labelConstants.GET_LABELS_LIST_FAILURE, err: e });
  }
}

function* addLabel(action: any) {
  try {
    const response: AxiosResponse = yield call(postLabel, action.payload);
    yield put({
      type: labelConstants.ADD_LABEL_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: labelConstants.ADD_LABEL_FAILURE, err: e });
  }
}

function* editLabelAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      editLabel,
      action.id,
      action.payload,
    );
    yield put({
      type: labelConstants.EDIT_LABEL_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: labelConstants.EDIT_LABEL_FAILURE, err: e });
  }
}

function* deleteLabelAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(deleteLabel, action.payload);
    yield put({
      type: labelConstants.DELETE_LABEL_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: labelConstants.DELETE_LABEL_FAILURE, err: e });
  }
}

function* labelSaga() {
  yield all([takeEvery(labelConstants.GET_LABELS_LIST, retrieveLabels)]);
  yield all([takeEvery(labelConstants.ADD_LABEL_REQ, addLabel)]);
  yield all([takeEvery(labelConstants.EDIT_LABEL_REQUEST, editLabelAsync)]);
  yield all([takeEvery(labelConstants.DELETE_LABEL_REQUEST, deleteLabelAsync)]);
}

export default labelSaga;
